import React from "react";

const Permission = () => {
    return(
        <>
            <p>Hi</p>
        </>
    )
}

export default Permission;